(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-yorumlari"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__igcReady) return;
      var track = root.querySelector('[data-igc-track]');
      if (!track) return;
      root.__igcReady = true;

      var prev = root.querySelector('[data-igc-prev]');
      var next = root.querySelector('[data-igc-next]');
      var dotsBox = root.querySelector('[data-igc-dots]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = reduce ? 'auto' : 'smooth';
      var ticking = false;

      function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function pageCount() { return Math.max(1, Math.round(track.scrollWidth / track.clientWidth)); }

      function stepSize() {
        var card = track.querySelector('.igc__card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
        var per = Math.max(1, Math.round((track.clientWidth + gap) / (card.offsetWidth + gap)));
        return (card.offsetWidth + gap) * per;
      }

      function buildDots() {
        if (!dotsBox) return;
        var n = pageCount();
        dotsBox.innerHTML = '';
        if (n < 2) return;
        for (var i = 0; i < n; i++) {
          var d = document.createElement('span');
          d.className = 'igc__dot';
          dotsBox.appendChild(d);
        }
      }

      function update() {
        ticking = false;
        var max = maxScroll();
        var scrollable = max > 2;
        root.classList.toggle('igc--static', !scrollable);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (dotsBox && dotsBox.children.length) {
          var n = dotsBox.children.length;
          var active = max > 0 ? Math.round((track.scrollLeft / max) * (n - 1)) : 0;
          for (var i = 0; i < n; i++) dotsBox.children[i].classList.toggle('is-active', i === active);
        }
      }

      function requestUpdate() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: behavior }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: behavior }); });
      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', function () { buildDots(); requestUpdate(); });

      // Tema düzenleyicisinde bir yorum seçilince ekrana kaydır
      root.addEventListener('shopify:block:select', function (e) {
        if (e.target && e.target.scrollIntoView) e.target.scrollIntoView({ inline: 'center', block: 'nearest', behavior: behavior });
      });

      buildDots();
      update();
      window.addEventListener('load', function () { buildDots(); update(); });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-igc]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
